import {
  CookiesSettings,
  CookiesSettingsProps,
  useCaseType,
} from '@rimactechnology/rimac-ui-lib';
import { getCookie, hasCookie, setCookie } from 'cookies-next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { useCookiesSettingsQuery } from '@/api';
import { cookieExpirationDate } from '@/constants/constants';

export const CookieSetting = () => {
  const { data } = useCookiesSettingsQuery();
  const [visible, setVisible] = useState(false);
  const [optionalCookies, setOptional] = useState(
    hasCookie('rgroup_cookie_consent_optional') &&
      getCookie('rgroup_cookie_consent_optional') === 'true',
  );
  const settingsData = data?.cookieSetting?.data?.attributes;

  const onSave = () => {
    setCookie('rgroup_cookie_consent_optional', optionalCookies, {
      expires: cookieExpirationDate,
    });
    setVisible(false);
  };

  const router = useRouter();

  useEffect(() => {
    if (window.location.hash && !visible) {
      const { pathname, search } = window.location;
      const newPath = pathname + search;
      router.replace(newPath, undefined, { shallow: true });
    }
  }, [router, visible]);

  useEffect(() => {
    const handleUrlChange = () => {
      if (window.location.hash.substring(1).includes('cookiesSettings')) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('hashchange', handleUrlChange);

    return () => {
      window.removeEventListener('hashchange', handleUrlChange);
    };
  }, []);

  const modalData: CookiesSettingsProps = {
    heading: settingsData?.title || '',
    closeModal: () => setVisible(false),
    useCase: 'group' as useCaseType,
    actionButton: {
      label: settingsData?.actionButtonLabel || '',
      onClick: () => onSave(),
      useCase: 'group',
    },
    moreInfoLink: {
      label: settingsData?.redirectButton?.label || '',
      path: settingsData?.redirectButton?.path || '',
      useCase: 'group' as useCaseType,
    },
    isModalOpen: visible,
    tableContentItems: [
      {
        heading: settingsData?.necessaryCookiesHeading || '',
        toggleSwitch: {
          initialValue: true,
          isFixed: true,
          onChange: () => {},
          useCase: 'group' as useCaseType,
        },
        tableContent: {
          parentIndex: 1,
          useCase: 'group',
          text: settingsData?.necessaryCookiesTable?.richText || '',
          tableData: {
            headings: (
              settingsData?.necessaryCookiesTable?.tableHead || []
            ).map((item) => item?.headingItem || ''),
            values: (
              settingsData?.necessaryCookiesTable?.tableRow?.table_rows?.data ||
              []
            ).map((row) =>
              (row.attributes?.rows || []).map((item) => item?.item || ''),
            ),
          },
        },
      },
      {
        heading: settingsData?.optionalCookiesHeading || '',
        toggleSwitch: {
          initialValue: optionalCookies,
          isFixed: false,
          onChange: () => setOptional(!optionalCookies),
          useCase: 'group' as useCaseType,
        },
        tableContent: {
          parentIndex: 2,
          useCase: 'group',
          text: settingsData?.optionalCookiesTale?.richText || '',
          tableData: {
            headings: (settingsData?.optionalCookiesTale?.tableHead || []).map(
              (item) => item?.headingItem || '',
            ),
            values: (
              settingsData?.optionalCookiesTale?.tableRow?.table_rows?.data ||
              []
            ).map((row) =>
              (row.attributes?.rows || []).map((item) => item?.item || ''),
            ),
          },
        },
      },
    ],
  };

  if (visible && data) return <CookiesSettings {...modalData} />;
};
